import React, { useEffect } from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingArgument } from './components/ClosingArgument';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { Guarantee } from './components/Guarantee';
import { Hero } from './components/Hero';
import { LessonsSection } from './components/LessonsSection';
import { PainPoints } from './components/PainPoints';
import { PricingSection } from './components/PricingSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { ProductGallery } from './components/ProductGallery';
import { SolutionReveal } from './components/SolutionReveal';
import { TestimonialsStrip } from './components/TestimonialsStrip';
import { VolumesSection } from './components/VolumesSection';
import { META_PIXEL_ID } from './utils/tracking';
type MetaPixel = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[][];
  push?: (...args: unknown[]) => void;
  loaded?: boolean;
  version?: string;
};
declare global {
  interface Window {
    fbq?: MetaPixel;
    _fbq?: MetaPixel;
  }
}
interface AppProps {
  showTestimonials?: boolean;
  showPurchaseNotifications?: boolean;
}
export function App({
  showTestimonials = true,
  showPurchaseNotifications = true
}: AppProps) {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    try {
      if (!window.fbq) {
        const pixel: MetaPixel = (...args: unknown[]) => {
          if (pixel.callMethod) pixel.callMethod(...args);else pixel.queue?.push(args);
        };
        pixel.queue = [];
        pixel.loaded = true;
        pixel.version = '2.0';
        pixel.push = (...args: unknown[]) => pixel(...args);
        window.fbq = pixel;
        window._fbq = pixel;
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        (document.head || document.body || document.documentElement).appendChild(script);
        window.fbq('init', META_PIXEL_ID);
      }
      window.fbq('track', 'PageView');
    } catch (error) {
      console.warn('Meta Pixel initialization failed:', error);
    }
  }, []);
  return <div className="min-h-screen w-full bg-white text-body" data-id="element-0" data-mp="86w6eufugc1w">
      <main data-id="element-1" data-mp="3gl4r7gc4jyji">
        <Hero data-id="element-2" data-mp="3gkuxpirvf992" />
        <ProductGallery data-id="element-3" data-mp="3gmfvdh9hf8b5" />
        {showTestimonials && <TestimonialsStrip data-id="element-4" data-mp="3gj1r23h9cp12" />}
        <PainPoints data-id="element-5" data-mp="3bmthr6pqrq1t" />
        <SolutionReveal data-id="element-6" data-mp="3bncso3gz5e6c" />
        <VolumesSection data-id="element-7" data-mp="3bo4kd37garrc" />
        <LessonsSection data-id="element-8" data-mp="3qb7i9azor2f7" />
        <BonusSection data-id="element-9" data-mp="3qbpkqpcxycvk" />
        <PricingSection data-id="element-10" data-mp="3qbze8mx73260" />
        <ClosingArgument data-id="element-11" data-mp="3qdaisoygsdy6" />
        <Guarantee data-id="element-12" data-mp="3lkhbpufiwtix" />
        <FAQ data-id="element-13" data-mp="3lk7mi92ayqea" />
        <FinalCTA data-id="element-14" data-mp="3ljg0npyic717" />
      </main>
      <Footer data-id="element-15" data-mp="3lieeapc1jy46" />
      {showPurchaseNotifications && <PurchaseNotification data-id="element-16" data-mp="2xud8ho68yvsg" />}
      <noscript data-id="element-17" data-mp="2xtlo79i3okhh">
        <img height="1" width="1" style={{
        display: 'none'
      }} alt="" src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-18" data-mp="2xt24pocsxo1c" />
      </noscript>
    </div>;
}